import script from "./baseMixins.vue?vue&type=script&lang=js"
export * from "./baseMixins.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__